import ReactDOM from "react-dom";
import React from "react";
import { Routes } from './../Core/Constants'
import { CatalogueProvider } from './../Providers/CatalogueProvider';
import LuigiAutocomplete from "./LuigiAutocomplete.jsx";
import MeiliAutocomplete from "./MeiliAutocomplete.jsx";

export default class SearchBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			searchTerm: this.props.searchString,
			showSuggest: false
		};
		this.inputRef = React.createRef();
	}

	handleKeyPress = (event) => {
		if (event.charCode === 13) {
			event.preventDefault();
			this.handleSumbmitSearch(event);
			return;
		}
	}

	handleChange = (event) => {
		// Not wired to the input at all for LuigiJs (see render()) - only reachable for
		// Internal/LuigiApi/MeiliSearch, hence no LuigiJs check needed here.
		if (event.target.value.length > 2 && this.props.searchProvider !== 'LuigiApi' && this.props.searchProvider !== 'MeiliSearch') {
			CatalogueProvider.getSuggestions(event.target.value, (data) => {
				this.setState({
					data: data,
					showSuggest: true
				});
			});
		} else {
			this.setState({
				showSuggest: false,
				data: [],
				searchTerm: event.target.value
			});
		}
		this.setState({
			searchTerm: event.target.value
		});
	}

	handleSumbmitSearch = (event) => {
		event.preventDefault();
		// LuigiJs doesn't track the field via React state (see render()), so read the
		// current value straight from the DOM instead of the (unmaintained) state.
		const searchTerm = this.props.searchProvider === 'LuigiJs'
			? (this.inputRef.current ? this.inputRef.current.value : '')
			: this.state.searchTerm;
		if (searchTerm) {
			// Server picks the internal/Luigi/Meili pipeline for Routes.Search based on
			// the configured SearchProvider - the client only needs to choose InternalSearch.
			const searchPath = window.InternalSearch ? Routes.InternalSearch : Routes.Search;
			window.location.href = searchPath + '?q=' + encodeURIComponent(searchTerm);
		}
	}

	renderSuggestion = () => {
		const T = window.Texts.search;
		const { showSuggest, data } = this.state;
		if (showSuggest) {
			return (
				<div className="dropdown-menu" style={{ display: 'block' }}>
					<div className="dropdown-menu-box">
						{(data.categories.length > 0) ?
							<div className="dropdown-menu__group">
								<div className="dropdown-menu__group--title"><p>{T ? T.Categories : 'Kategorie'}</p><hr /></div>
								{data.categories.map((item, i) => {
									return (
										<div className="dropdown-menu__group--item category" key={'kat' + item.id}>
											<div className="content" onClick={() => window.location = item.url}>
												<div className="thumb"><img src="/Content/view/images/icon-folder.svg" alt="folder" /></div>
												<div className="text"><p>{item.shortPathName}</p></div>
											</div>
											<div className="arrow"><img src="/Content/view/images/icon-arrow.svg" alt="arrow" /></div>
										</div>);
								})}
							</div> : null}

						{(data.products.length > 0) ?
							<div className="dropdown-menu__group">
								<div className="dropdown-menu__group--title"><p>{T ? T.Products : 'Zboží'}</p><hr /></div>
								{data.products.map((item, i) => {
									return (
										<div className="dropdown-menu__group--item" key={'product' + item.id}>
											<div className="content" onClick={() => window.location = item.url}>
												<div className="thumb"><img src={item.photo.url} /></div>
												<div className="text"><p><strong>{item.name}</strong></p><br />
													<p dangerouslySetInnerHTML={{ __html: item.displayAvailability }}></p>
												</div>
											</div>
											<div className="arrow"><img src="/Content/view/images/icon-arrow.svg" alt="arrow" /></div>
										</div>);
								})}
							</div> : null}
					</div>
					<div className="dropdown-menu__group--footer"><a onClick={(e) => this.handleSumbmitSearch(e)} className="btn">{T ? T.NextProducts : 'Další zboží'}</a></div>
				</div>
			);
		}
	}

	render = () => {
		const { handleChange, renderSuggestion } = this
		// LuigiJs: the LBX box script (_Head.cshtml) already provides its own autocomplete on #searchphrase,
		// so autocomplete.js must NOT also be loaded here - it would run a second, competing widget on the same input.
		// LuigiApi has no box script, so it needs autocomplete.js to get Luigi-quality suggestions.
		const isLuigiJs = this.props.searchProvider === 'LuigiJs';
		const hasOwnWidget = isLuigiJs || this.props.searchProvider === 'LuigiApi' || this.props.searchProvider === 'MeiliSearch';
		const showGenericSuggestion = !hasOwnWidget;
		const luigiAutocompleteEnabled = this.props.searchProvider === 'LuigiApi';
		return (
			<React.Fragment>
				<div className="form-group">
					{isLuigiJs ?
						// Plain, uncontrolled field - no onInput/onFocus/onBlur, so the LBX box
						// script can own #searchphrase without fighting React's controlled value.
						<input ref={this.inputRef} defaultValue={this.state.searchTerm} autoComplete="off" onKeyPress={(e) => this.handleKeyPress(e)} name="searchphrase" type="text" id="searchphrase" />
						:
						<input value={this.state.searchTerm} autoComplete="off" onFocus={this.handleChange} onKeyPress={(e) => this.handleKeyPress(e)} name="searchphrase" type="text" id="searchphrase" onInput={(e) => handleChange(e)} onBlur={() => setTimeout(() => this.setState({ showSuggest: false }), 200)} />
					}
					<button type="submit" onClick={(e) => this.handleSumbmitSearch(e)}/>
				</div>
				{showGenericSuggestion && renderSuggestion()}
				<LuigiAutocomplete enabled={luigiAutocompleteEnabled} langId={this.props.langId} luigiTrackerId={this.props.luigiTrackerId} />
				<MeiliAutocomplete enabled={this.props.searchProvider === 'MeiliSearch'} />

			</React.Fragment>
		);
	}
}

//inicializace
var element = document.getElementById("app-search-form");
if (element) {
	var searchString = element.getAttribute('data-search');
	var enabledLuigi = element.getAttribute('data-enabled-luigi')?.toLowerCase() === 'true';
	var searchProvider = element.getAttribute('data-search-provider');
	var luigiTrackerId = element.getAttribute('data-luigi-trackerId');
	var langId = element.getAttribute('data-id-lang');

	ReactDOM.render(<SearchBox
		searchString={searchString}
		enabledLuigi={enabledLuigi}
		searchProvider={searchProvider}
		luigiTrackerId={luigiTrackerId}
		langId={langId} />, element);
}
